import React from 'react';
import { WhizzEducationLogo } from '@whizz/react-branding';

const Footer = (): JSX.Element => {
  return (
    <footer className={'w-full p-md bg-white text-muted border-t border-gray-300'}>
      <WhizzEducationLogo dark className='h-12'/>
    </footer>
  );
};

Footer.displayName = 'Footer';

export default Footer;
